// core
import React from 'react';
import { Link } from 'react-router-dom'
import { Provider } from "react-redux"

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// page-specific/etc.

class MailingEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'edit',
      working: false,
      fetching: false,
      fetchingLists: false,

      error: '',

      lists: [],
      checkedListsById: {},

      mailing: {
        name: '',
        html_body: ''
      },

      testRecipients: [],
      sendingTest: false,
      testSuccess: false,

      realRecipients: [],
      realNumSent: 0,
      realNumErrors: 0,
      sendingReal: false,
      realSuccess: false
    };

    this.toggleList = this.toggleList.bind(this);

    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescrChange = this.handleDescrChange.bind(this);

    this.handleTestRecipientsUpdate = this.handleTestRecipientsUpdate.bind(this);

    this.replaceTags = this.replaceTags.bind(this);
    this.handleSendTest = this.handleSendTest.bind(this);
    this.handleSendAll = this.handleSendAll.bind(this);
  }

  componentDidMount() {
    const { mailingId } = this.props.match.params;

    // get this mailing
    if (mailingId && mailingId != 'new') {
      this.setState({
        fetching: true
      });

      API.call('GET', Settings.V3_API_URL + '/mailing-queues/' + mailingId, {}, (response, error) => {
        if (error) {
          this.setState({
            fetching: false,

            error: error.message + ' while getting queue'
          });

          return false;
        }

        // convert form to object
        var mailing = response.data.mailing;
        mailing.form = JSON.parse(mailing.form);

        this.setState({
          mailing: mailing
        });
      });
    }

    // get lists
    this.setState({
      fetchingLists: true
    }, () => {
      API.call('GET', Settings.V3_API_URL + '/recipient-lists', {}, (response, error) => {
        this.setState({
          fetchingLists: false
        });

        if (error) {
          this.setState({
            error: error.message + ' while getting lists'
          });

          return false;
        }

        this.setState({
          lists: response.data.lists
        });
      });
    });
  }

  toggleList(e, list) {
    console.log('Tottle list', list);
    const checked = e.currentTarget.checked;

    this.setState((prevState) => {
      if (checked) {
        prevState.checkedListsById[list.id] = checked;
      } else {
        let lists = {};

        Object.keys(prevState.checkedListsById).forEach((listId) => {
          if (listId != list.id) {
            lists[listId] = true;
          }
        });

        prevState.checkedListsById = lists;
      }

      return prevState;
    });
  }

  handleTitleChange(e) {
    var name = e.target.value;

    return this.setState((prevState) => {
      prevState.mailing.name = name;

      return prevState;
    });
  }
  handleDescrChange(e) {
    var html_body = e.target.value;

    return this.setState((prevState) => {
      prevState.mailing.html_body = html_body;

      return prevState;
    });
  }

  handleTestRecipientsUpdate(e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.testRecipients = value.split(',').map((email) => {
        return email.trim();
      });

      return prevState;
    });
  }

  replaceTags(body, recipient) {
    if (body.indexOf('%PE_NOME%') != -1 || body.indexOf('%PE_CONOME%') != -1) {
      alert('nome/cognome utente non supportato');
    }

    // replace tags in message
    const unsubscribeLink = 'https://www.progettieducativi.it/unsubscribe/?email=' + recipient + '&token=WOSHSKj73'; // TODO: hash toket
    const unsubscribeBlock = '<p style="color: #000; text-align: center;"><a style="color: #000;" href="' + unsubscribeLink + '">Clicca qui</a> per cancellarti</p>';

    body = body.replace('%PE_NOME%', ''); // TODO: we don't have first/last name :-/
    body = body.replace('%PE_COGNOME%', ''); // TODO: we don't have first/last name :-/
    body = body.replace('%PE_BLOCCO_CANCELLAMI%', unsubscribeBlock);

    return body;
  }

  handleSendTest() {
    if (this.state.testRecipients.length) {
      console.log('Have recipients!');

      const endpoint = Settings.V3_API_URL + '/emails';
      let numSent = 0;

      this.setState((prevState) => {
        prevState.sendingTest = true;
        prevState.testSuccess = false;
        prevState.error = '';

        return prevState;
      }, () => {
        this.state.testRecipients.forEach((recipient) => {
          const body = this.replaceTags(this.state.mailing.html_body, recipient);

          API.call('POST', endpoint, {
            to: recipient,
            from: Settings.MAILGUN_FROM,

            subject: this.state.mailing.name,
            html: body,
            tags: [
              'test',
              'colibri-libri-dashboard-mailing-v2-test'
            ]
          }, (response, error) => {
            if (error) {
              this.setState({
                sendingTest: false,
                testSuccess: false,

                error: error.message + ' while sending test email(s)'
              });

              return false;
            }

            if (!response.ok) {
              this.setState({
                sendingTest: false,
                testSuccess: false,

                error: response.error + ' while sending test email(s)'
              });

              return false;
            }

            console.log('Email ' + recipient + ' sent!');

            numSent++;
            if (numSent == this.state.testRecipients.length) {
              this.setState((prevState) => {
                prevState.sendingTest = false;
                prevState.testSuccess = true;
                prevState.error = '';

                return prevState;
              });

              window.setTimeout(() => {
                this.setState((prevState) => {
                  prevState.testSuccess = false;

                  return prevState;
                });
              }, 2000);
            }
          });
        });
      });
    } else {
      alert('no recipient(s)');
    }
  }

  handleSendAll() {
    // make list of recipients
    let recipients = [];
    this.state.lists.forEach((list) => {
      if (this.state.checkedListsById[list.id]) {
        list.teachers.forEach((teacherKey) => {
          // let's use the teacher key to get the email, since teachers aren't currently cached, and we can avoid fetching them here this way
          let email = teacherKey.split('_')[0].toLowerCase();
          if (email) recipients.push(email);
        });

        list.schools.forEach((schoolId) => {
          console.log('School ID: ' + schoolId);
          let school = this.props.appData.cache.schoolsById[schoolId];
          console.dir(school);
          if (!school) {
            console.error('school not found with ID ' + schoolId);
          }

          if (school.email) recipients.push(school.email);
        });

        list.emails.forEach((email) => {
          console.log('Email: ' + email);

          recipients.push(email);
        });
      }
    });
    recipients = recipients.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    if (recipients.length) {
      // confirm
      if (!window.confirm('Sei sicuro/a di voler spedire mailing a ' + recipients.length + ' destinatari!?')) {
        return;
      }

      // create DB record of mailing
      let method, endpoint;
      if (this.state.mailing.id) {
        method = 'PUT';
        endpoint = Settings.V3_API_URL + '/mailing-queues/' + this.state.mailing.id;
      } else {
        method = 'POST';
        endpoint = Settings.V3_API_URL + '/mailing-queues';
      }

      const payload = this.state.mailing;

      // use name for subject
      payload.subject = payload.name;

      // add lists
      payload.lists = Object.keys(this.state.checkedListsById);

      API.call(method, endpoint, payload, (response, error) => {
        this.setState({
          fetching: false
        });

        const err = error ? error.message : response.error;
        if (err) {
          this.setState({
            error: err
          });

          return false;
        }

        if (!response || !response.data || !response.data.queue.id) {
          this.setState({
            error: 'no queue ID!!!'
          });

          return false;
        }

        this.setState((prevState) => {
          // info about mailing queue
          prevState.mailing = response.data.queue;

          // info about emails
          prevState.realRecipients = recipients;
          prevState.sendingReal = true;
          prevState.realNumSent = 0;
          prevState.realNumErrors = 0;
          prevState.realSuccess = false;

          prevState.error = '';

          return prevState;
        }, () => {
          this.setState((prevState) => {
            prevState.status = 'saved';

            return prevState;
          });

          /*
          // now, do the actual sending
          const endpoint = Settings.V3_API_URL + '/emails';
          let numSent = 0;
          let numErrors = 0;

          // send all at 5 requests at a time
          let recipients = this.state.realRecipients.slice(0);
          while (recipients.length > 0) {
            let c = recipients.splice(0, 5);
            let promises = [];

            for (let i=0; i < c.length; i++) {
              const recipient = c[i];
              const body = this.replaceTags(this.state.mailing.html_body, recipient);

              promises.push(
                fetch(endpoint, {
                  method: 'post',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': Auth.getToken() ? ('Bearer ' + Auth.getToken()) : ''
                  },
                  body: JSON.stringify({
                    to: recipient,
                    from: Settings.MAILGUN_FROM,

                    subject: this.state.mailing.name,
                    html: body,
                    tags: [
                      'test',
                      'colibri-libri-dashboard-mailing-v2-' + this.state.mailing.id
                    ]
                  })
                })
                .then((response) => {
                  return response.json()
                })
                .then((response) => {
                  if (!response.ok) {
                    numErrors++;

                    console.error('Email ' + recipient + ' FAIL!');
                  } else {
                    numSent++;

                    console.log('Email ' + recipient + ' sent!');
                  }

                  this.setState((prevState) => {
                    prevState.realNumSent = numSent;
                    prevState.realNumErrors = numErrors;

                    return prevState;
                  }, () => {
                    if ((this.state.realNumSent + this.state.realNumErrors) == this.state.realRecipients.length) {
                      this.setState((prevState) => {
                        prevState.status = 'saved';

                        return prevState;
                      });
                    }
                  });
                })
              );
            }

            Promise.all(promises)
          }
          */
        });
      });
    }
  }

  render() {
    let numSchools = 0;
    let numTeachers = 0;
    let numManualEmails = 0;

    console.log('LISTS', this.state.checkedListsById, this.state.lists);

    this.state.lists.forEach((list) => {
      if (this.state.checkedListsById[list.id]) {
        console.log('YES, YES!', list);

        numSchools += list.schools.length;
        numTeachers += list.teachers.length;
        numManualEmails += list.emails.length;

        console.log('numManualEmails', numManualEmails);
      }
    });

    return (
      <div>
        <div className="container">
          {
            this.state.status == 'edit' ? (
              <div>
                <div className="row">
                  <div className="col-md-8">
                    <h1><i className="fa fa-stream" /> {this.state.mailing && this.state.mailing.id ? "Aggiorna mailing" : "Crea nuovo mailing"}</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    {
                      this.state.fetching || this.state.working ? <Spinner message="Attendere..." /> : ""
                    }
                  </div>
                </div>

                <div className="mt-4">
                  <div className="row">
                    <div className="col-8">
                      <h2>Seleziona lista/e {numTeachers || numSchools || numManualEmails ? <small>({numTeachers} insegnanti, {numSchools} scuole, {numManualEmails} destinatari hardcodati selezionati)</small> : ''}</h2>
                  </div>
                    <div className="col-4 text-right">
                      <Link to="/marketing/lists/new/" className="btn btn-primary"><i className="fa fa-plus" /> Crea nuova lista</Link>
                    </div>
                  </div>

                  <hr />

                  {
                    this.state.fetchingLists && (
                      <p><Spinner message="Recupero liste, attendere..." /></p>
                    )
                  }

                  {
                    this.state.lists.map((list) => {
                      return (
                        <table width="100%" border="0">
                          <tr style={{paddingBottom: '10px', borderBottom: '1px solid #aaa'}}>
                            <td width="20px" align="left" valign="middle" style={{padding: '10px 5px 10px 0', borderRight: '0px solid #ccc'}}>
                              <input type="checkbox" checked={this.state.checkedListsById[list.id]} onChange={(e) => this.toggleList(e, list)} />
                            </td>
                            <td align="left" valign="middle" style={{padding: '10px 0 10px 10px'}}>
                              <h4 className="mb-0" style={{fontSize: '16px'}}>{list.name}</h4>
                              {list.descr ? <p className="mt-1 mb-0">{list.descr}</p> : ''}
                            </td>
                            <td align="right" valign="middle">
                              <big>{list.schools.length}</big> scuole<br />
                              <big>{list.teachers.length}</big> insegnanti<br />
                              <big>{list.emails.length}</big> destinatari hardcodati
                            </td>
                          </tr>
                        </table>
                      );
                    })
                  }

                  <h2 className="mt-4">Info mailing</h2>
                  <div className="form-group">
                    <label for="mailing_editor_mailing_name">Nome <span className="text-danger">*</span></label>

                    <input className="form-control" type="text" id="mailing_editor_mailing_name" value={this.state.mailing ? this.state.mailing.name : ""} onChange={this.handleTitleChange} />
                  </div>
                  <div className="form-group">
                    <label for="mailing_editor_mailing_html_body">Codice HTML</label>

                    <textarea rows="15" className="form-control" id="mailing_editor_mailing_html_body" value={this.state.mailing ? this.state.mailing.html_body : ""} onChange={this.handleDescrChange}></textarea>
                  </div>

                  <h2><i className="fa fa-paper-plane" />  Spedizione</h2>
                  {
                    this.state.error ? (
                      <div className="alert alert-danger"><h2>Oh, mamma!</h2><p>{this.state.error}</p></div>
                    ) : ''
                  }

                  <div className="mt-3">
                    <h3>Spedisci mail di prova</h3>
                    <p>
                      {
                        this.state.sendingTest ? (
                          <Spinner message="Spedisco test..." />
                        ) : ''
                      }
                      {
                        !this.state.sendingTest && this.state.testSuccess ? (
                          <span>
                            <i className="fa fa-check text-success" /> {this.state.testRecipients.length} email di prova {this.state.testRecipients.length == 1 ? 'spedita' : 'spedite'}
                          </span>
                        ) : ''
                      }
                      {
                        !this.state.sendingTest && !this.state.testSuccess ? (
                          <React.Fragment>
                            <p>Puoi mandare a più indirizzi separandoli da virgola.</p>
                            <input type="email" className="form-control" style={{maxWidth: '500px', float: 'left'}} onChange={this.handleTestRecipientsUpdate} value={this.state.testRecipients.join(', ')} />
                            <button className="btn btn-primary" style={{float: 'left', marginLeft: '1rem'}} onClick={this.handleSendTest}>Spedisci <i className="fa fa-envelope ml-1" /> <i className="fa fa-arrow-right" /></button>
                          </React.Fragment>
                        ) : ''
                      }
                    </p>

                    <div className="clearfix" />
                  </div>

                  <hr />

                  <div className="mt-4">
                    <h3>Spedisci mail a lista/e</h3>
                    {
                      this.state.sendingReal == false ? (
                        <div>
                          <p>Clicca per creare il mailing e spedire a tutti i destinatari della lista ({numTeachers} insegnanti, {numSchools} scuole, {numManualEmails} destinatari hardcodati).</p>
                          <p className="mt-3"><button className="btn btn-primary" onClick={this.handleSendAll}>Spedisci a {numTeachers + numSchools + numManualEmails} destinatari <i className="fa fa-envelope ml-1" /> <i className="fa fa-arrow-right" /></button></p>
                        </div>
                      ) : (
                        <div>
                        <h4><Spinner message={'Spedisco ' + (this.state.realNumSent + this.state.realNumErrors) + ' su ' + this.state.realRecipients.length} /></h4>
                        <p className="mt-3">
                          OK: {this.state.realNumSent} spedite<br />
                          Errori: {this.state.realNumErrors}
                        </p>
                      </div>
                      )
                    }
                  </div>
                </div>
              </div>
            ) : ''
          }
          {
            this.state.status == 'saved' ? (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <h1>Mailing processata.</h1>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <h3><Link to={'/marketing/mailings/' + this.state.mailing.id + '/view/'}><i className="fa fa-arrow-right" /> Vai alle statistiche</Link></h3>
                  </div>
                </div>
              </div>
            ) : ''
          }
        </div>
      </div>
    );
  }
}

export default MailingEditorPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/mailings/MailingEditorPage.js